import React, { useState } from 'react';
import { Modal, Button, Form, InputGroup, Row, Col } from 'react-bootstrap';

import ApiServiceServerless from '../../../xhr_libs';
import SmallerLoader from '../../SmallerLoader';
import DatePicker from 'react-datepicker';

const date_options = {
  "statement": 'Statement Date',
  'bill': 'Period End Date',
}

export default function PlugBulkDownloadModal(props) {
  const { show, onHide, credential, organizationId, showToast } = props;


  const [dateOption, setDateOption] = useState('statement')
  const [localDate, setLocalDate] = useState(new Date())
  const [isLoading, setIsLoading] = useState(false);


  const requestDownload = () => {
    setIsLoading(true);


    ApiServiceServerless.post(
      'providers/download-bulk-pdfs',
      {
        method: 'date',
        date: localDate,
        date_option: dateOption,
        credential_id: credential['id'],
        provider_name: credential['utilityProvider']
      },
      { authorization_id: organizationId }
    )
      .then(() => {
        showToast('success', 'Success', 'Gathering your bills now. Please allow a few minutes for download and then you will receive an email with a download link');
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        setIsLoading(false);
        onHide();
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton={!isLoading}>
        Download PDF Statements by Date
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col></Col>
          <Col md={5}>   <Form.Row>
            <Form.Group>
              <Form.Label>Date Option</Form.Label>
              <Form.Control
                style={{ width: '125%' }}
                as='select'
                onChange={(e) => setDateOption(e.target.value)}
                value={dateOption}
              >

                {Object.keys(date_options).map((opt) => (
                  <option key={`date-opt-${opt}`} value={opt}>
                    {date_options[opt]}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row></Col>
          <Col></Col>
        </Row>
        <Row>
          <Col></Col>
          <Col md={5}>   <Form.Row>
            <Form.Group>
              <Form.Label>Bill Date</Form.Label>
              <InputGroup size='sm'>
                <DatePicker
                  selected={localDate}
                  dateFormat='MM/yyyy'
                  onChange={(date) => setLocalDate(date)}
                  showMonthYearPicker
                  showTwoColumnMonthYearPicker
                />
              </InputGroup>
            </Form.Group>
          </Form.Row></Col>
          <Col></Col>
        </Row>

      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='primary'
          onClick={() => requestDownload()}
          disabled={
            isLoading

          }
        >
          {isLoading && <SmallerLoader text={'Generating...'} />}
          {!isLoading && <> Download Bills</>}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
